module.exports = __webpack_public_path__ + "static/media/logo-dark-en.2ad79a5f.svg";